// extracted by mini-css-extract-plugin
module.exports = {"richText":"RichText_richText__a2PZC"};